var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocsGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V14C0 16.2091 1.79086 18 4 18H14C16.2091 18 18 16.2091 18 14V4C18 1.79086 16.2091 0 14 0H4ZM4.65338 4.30713C4.23917 4.30713 3.90338 4.64292 3.90338 5.05713C3.90338 5.47134 4.23917 5.80713 4.65338 5.80713H13.3465C13.7607 5.80713 14.0965 5.47134 14.0965 5.05713C14.0965 4.64292 13.7607 4.30713 13.3465 4.30713H4.65338ZM3.90338 9.05127C3.90338 8.63706 4.23917 8.30127 4.65338 8.30127H9.65338C10.0676 8.30127 10.4034 8.63706 10.4034 9.05127C10.4034 9.46548 10.0676 9.80127 9.65338 9.80127H4.65338C4.23917 9.80127 3.90338 9.46548 3.90338 9.05127ZM4.65338 12.2954C4.23917 12.2954 3.90338 12.6312 3.90338 13.0454C3.90338 13.4596 4.23917 13.7954 4.65338 13.7954H13.3465C13.7607 13.7954 14.0965 13.4596 14.0965 13.0454C14.0965 12.6312 13.7607 12.2954 13.3465 12.2954H4.65338Z",
    fill: "#8C8C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsGreyIcon);
export default __webpack_public_path__ + "static/media/docs-grey-icon.117cafbbc2062f24141b13b0e33ee339.svg";
export { ForwardRef as ReactComponent };